import { render, staticRenderFns } from "./TravelChargeColumn.vue?vue&type=template&id=fe18ee24&"
import script from "./TravelChargeColumn.vue?vue&type=script&lang=js&"
export * from "./TravelChargeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports